export const INITIAL_VALUES = {
  dateEvents: '',
  name: '',
};
